import api from "@/core/api";

export const barcodesFind = (barcode: string) => api.query(`/barcodes/barcode/${barcode}`, { method: "get" }, false);
